module.exports = __webpack_public_path__ + "img/icon(21).d397c869.png";